/* Paging reloads the page, which lands the reader at the top of the document —
   above the search field, the sort and the tabs — rather than at the results
   they were reading. Shopify's default_pagination emits plain links and the
   results are server-rendered, so there is no in-place update to hook: instead,
   on arriving at any page but the first, put the results back under the eye.
   Done before paint and without animation, so it reads as landing there rather
   than as a jump. */
(() => {
  const page = Number(new URLSearchParams(location.search).get('page') || 1);
  if (page <= 1) return;
  const grid = document.querySelector('.oracura-search__grid');
  if (!grid) return;
  grid.scrollIntoView({ block: 'start', behavior: 'instant' });
})();

/* The sort menu is a <details>, which on its own only closes from its pill:
   it now also closes on Escape, with focus back on the pill, and on a press
   anywhere outside it. */
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('details.oracura-search__sort[open]').forEach(menu => {
    menu.removeAttribute('open');
    menu.querySelector('summary')?.focus();
  });
});
document.addEventListener('pointerdown', event => {
  document.querySelectorAll('details.oracura-search__sort[open]').forEach(menu => {
    if (!menu.contains(event.target)) menu.removeAttribute('open');
  });
});

/* The classic card's LITE/PRO switch (Theme settings > Product cards >
   Classic); the current card has its own script, assets/oracura-shop-card.js. */
document.querySelectorAll('.oracura-search').forEach(root => {
  root.addEventListener('click', event => {
    const model = event.target.closest('[data-plp-model]');
    if (!model) return;
    event.preventDefault();
    const card = model.closest('.oracura-pcard');
    if (!card || card.querySelector('[aria-busy="true"]')) return;
    card.querySelectorAll('[data-plp-model]').forEach(button => {
      button.classList.toggle('oracura-pcard__tier--primary', button === model);
      button.setAttribute('aria-pressed', String(button === model));
    });
    card.querySelector('.oracura-pcard__price-now').textContent = model.dataset.price;
    // A chosen option has one price, so the card's "From" goes.
    card.querySelector('.oracura-pcard__price-from')?.remove();
    const mrp = card.querySelector('.oracura-pcard__price-mrp');
    mrp.hidden = !model.dataset.mrp;
    mrp.textContent = (mrp.dataset.mrpLabel || 'MRP') + ' ' + model.dataset.mrp;
    const badge = card.querySelector('[data-sale-badge]');
    // The corner badge only from the card's floor (data-badge-min).
    const pct = Number(model.dataset.pct) || 0;
    if (badge) { badge.hidden = !pct || pct < (Number(badge.dataset.badgeMin) || 0); badge.textContent = pct + '% ' + (badge.dataset.suffix || 'OFF'); }
    const link = card.querySelector('.oracura-pcard__link');
    const url = new URL(link.href);
    url.searchParams.set('variant', model.dataset.variantId);
    link.href = url;
    const add = card.querySelector('[data-plp-add]');
    if (add) {
      const available = model.dataset.available !== 'false';
      add.dataset.plpAdd = model.dataset.variantId;
      add.disabled = !available;
      add.classList.toggle('oracura-pcard__add--soldout', !available);
      const text = add.querySelector('.oracura-pcard__add-text');
      if (text) text.textContent = available ? add.dataset.addLabel : add.dataset.soldoutLabel;
      const icon = add.querySelector('.oracura-pcard__add-icon');
      if (icon) icon.hidden = !available;
    }
  });
});
